import { Step } from './../components/_common/steppers/steps/step';
import { observable, action, computed } from 'mobx';
import { KycStatus } from '../models/dtos/kyc';
import { KycApi } from '../apis/kycApi';
import { CompanyStore } from './companyStore';

export interface PageStep {
  step: Step;
  active: boolean;
  location: string;
}

// loanPartnerId: 1=Advance, 2=NetBank, 3=Unobank
const NETBANK_LOAN_PARTNER_ID = 2;

export class PageStepperStore {
  @observable
  private _kycStatus: KycStatus | null = null;

  @observable
  private _kycStatusFetched: boolean = false;

  @observable
  private _activeStepIndex: number = 0;

  private kycApi: KycApi;
  private companyStore: CompanyStore;

  constructor(companyStore: CompanyStore) {
    this.kycApi = new KycApi();
    this.companyStore = companyStore;
  }

  @computed
  get pageSteps(): PageStep[] {
    const isNetbank =
      this.companyStore.hasCompanySetting &&
      this.companyStore.loanPartnerId === NETBANK_LOAN_PARTNER_ID;

    if (
      !isNetbank &&
      (this._kycStatus === KycStatus.NotStarted ||
        this._kycStatus === KycStatus.Expired)
    ) {
      return [
        {
          step: { number: 1, label: 'Amount' },
          active: this._activeStepIndex === 0,
          location: '/loan-amount-selection',
        },
        {
          step: { number: 2, label: 'Purpose' },
          active: this._activeStepIndex === 1,
          location: '/reason',
        },
        {
          step: { number: 3, label: 'Verify Identity' },
          active: this._activeStepIndex === 2,
          location: '/verify-identity',
        },
        {
          step: { number: 4, label: 'Review & Submit' },
          active: this._activeStepIndex === 3,
          location: '/agreement',
        },
      ];
    }

    return [
      {
        step: { number: 1, label: 'Amount' },
        active: this._activeStepIndex === 0,
        location: '/loan-amount-selection',
      },
      {
        step: { number: 2, label: 'Purpose' },
        active: this._activeStepIndex === 1,
        location: '/reason',
      },
      {
        step: { number: 3, label: 'Review & Submit' },
        active: this._activeStepIndex === 2,
        location: '/agreement',
      },
    ];
  }

  @action
  async fetchKycStatus(borrowerId: number): Promise<void> {
    try {
      const response = await this.kycApi.getKycStatus(borrowerId);
      this._kycStatus = response.statusId;
      this._kycStatusFetched = true;
    } catch (error) {
      console.error('Failed to fetch KYC status:', error);
      this._kycStatus = null;
      this._kycStatusFetched = true;
    }
  }

  @action
  setActiveIndex(index: number) {
    this._activeStepIndex = index;
  }

  @computed
  get kycStatus(): KycStatus | null {
    return this._kycStatus;
  }

  @computed
  get kycStatusFetched(): boolean {
    return this._kycStatusFetched;
  }
}
